import Chatbot from "@/types/Chatbot.interface"

interface State {
    chatbotsCount: number
    chatbots: Chatbot[]
}

const defaults = () => {
    return {
        chatbotsCount: 0,
        chatbots: []
    }
}

export default {
    state: defaults(),
    mutations: {
        chatbotsCountSet (state: State, count: number): void {
            state.chatbotsCount = count
        },
        chatbotsPush (state: State, chatbots: Chatbot[]): void {
            state.chatbots = window.removeDuplicatesById(state.chatbots, chatbots)
        },
        chatbotsRemove (state: State, ids: number[]): void {
            //  Get our global list of chatbots
            const chatbots = state.chatbots

            //  If no chatbots, do nothing
            if (!chatbots) return

            //  Else, filter out our removed ids
            const filtered = chatbots.filter((x: Chatbot) => !ids.includes(x.id))

            //  Replace our list with the filtered list
            state.chatbots = filtered
        },
        chatbotsReset (state: State): void {
            Object.assign(state, defaults())
        },
        chatbotsSet (state: State, chatbots: Chatbot[]): void {
            state.chatbots = chatbots
        }
    },
    actions: {
        chatbotsCount ({ commit, getters }): Promise<number> {
            //  Assemble the API endpoint
            const url = `${getters.api}/chatbots/count`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our chatbot count
                commit('chatbotsCountSet', response.data)

                //  Return the total chatbots count
                return response.data
            }).catch(() => null)
        },
        chatbotsDelete ({ commit, getters }, chatbotId: number): Promise<Chatbot> {
            //  Assemble the API endpoint
            const url = `${getters.api}/chatbots/${chatbotId}`

            //  Send the request
            return window.axios.delete(url).then(response => {
                //  Update our chatbots
                commit('chatbotsRemove', [response.data.id])

                //  Update our chatbots view
                commit('chatbotsViewChatbotsRemove', [response.data.id])

                //  Return the deleted chatbot
                return response.data
            }).catch(() => null)
        },
        chatbotsFind ({ getters }, chatbotId: number): Promise<Chatbot> {
            //  Assemble the API endpoint
            const url = `${getters.api}/chatbots/${chatbotId}`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Return our found chatbot
                return response.data
            }).catch(() => null)
        },
        chatbotsGet ({ commit, getters }): Promise<Chatbot> {
            //  Assemble the API endpoint
            const url = `${getters.api}/chatbots`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Set our chatbot list
                commit('chatbotsSet', response.data)

                //  Set our chatbots view
                commit('chatbotsViewChatbotsSet', response.data)

                //  Return the chatbot
                return response.data
            }).catch(() => null)
        },
        chatbotsPost ({ commit, getters }, chatbot: Chatbot): Promise<Chatbot> {
            //  Assemble the API endpoint
            const url = `${getters.api}/chatbots`

            //  Send the request
            return window.axios.post(url, chatbot).then(response => {
                //  Update our global list
                commit('chatbotsPush', [response.data])

                //  Update our chatbots view chatbots
                commit('chatbotsViewChatbotsPush', [response.data])

                //  REturn our created chatbot
                return response.data
            }).catch(() => null)
        },
        chatbotsPut ({ commit, getters }, chatbot: Chatbot): Promise<Chatbot> {
            //  Assemble the API endpoint
            const url = `${getters.api}/chatbots`

            //  Send the request
            return window.axios.put(url, chatbot).then(response => {
                //  Update our global list
                commit('chatbotsPush', [response.data])

                //  Update our chatbots view chatbots
                commit('chatbotsViewChatbotsPush', [response.data])
                
                //  Return the updated chatbot
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        chatbots (state: State): Chatbot[] {
            return state.chatbots
        },
        chatbotsCount (state: State): number {
            return state.chatbotsCount
        }
    }
}
